import { render, staticRenderFns } from "./EventRemoveModal.vue?vue&type=template&id=a021fba8&"
import script from "./EventRemoveModal.vue?vue&type=script&lang=js&"
export * from "./EventRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./EventRemoveModal.vue?vue&type=style&index=0&id=a021fba8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports